import _ from "lodash"
const initial_state = {
    rightsInfo:"",
    updatedRights:""
}

export default function (state = initial_state,action){
    switch(action.type){
        case 'rights':
         
        return{
            ... state,
            rightsInfo:action.payload
        }
        default:
        return{
            ... state
        }
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/rights.js